import { render, staticRenderFns } from "./DailySales.vue?vue&type=template&id=60f39808&"
import script from "./DailySales.vue?vue&type=script&lang=js&"
export * from "./DailySales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports